export default function lineBreakParagraph(text: string): string {
  if (!text) {
    return text // Bail out early if there's no text
  }

  // Match any period, exclamation point, or question mark followed by a space and an uppercase letter
  const newSentenceMatcher = /([.!?]) (?=[A-Z])/g

  let result = ''
  let lastIndex = 0
  let sentenceCount = 0

  for (const match of text.matchAll(newSentenceMatcher)) {
    if (match.index !== undefined) {
      sentenceCount++
      if (sentenceCount === 2) {
        result += `${text.slice(lastIndex, match.index + 1)}\n\n`
        lastIndex = match.index + 2
        sentenceCount = 0
      }
    }
  }

  result += text.slice(lastIndex)

  return result
}
